export const PHASE1_SKIPPED_KEY = '_phase1SkippedQuestions';

export const isPhase1QuestionSkipped = (formData, question) =>
  Boolean(question?.optional && formData?.[PHASE1_SKIPPED_KEY]?.[question.field]);

export const markPhase1QuestionSkipped = (formData, question) => {
  if (!question?.optional || !question.field) return formData;
  return {
    ...formData,
    [PHASE1_SKIPPED_KEY]: {
      ...(formData?.[PHASE1_SKIPPED_KEY] || {}),
      [question.field]: true,
    },
  };
};

export const clearPhase1QuestionSkipped = (formData, question) => {
  if (!question?.field || !formData?.[PHASE1_SKIPPED_KEY]?.[question.field]) return formData;
  const skipped = { ...formData[PHASE1_SKIPPED_KEY] };
  delete skipped[question.field];
  return { ...formData, [PHASE1_SKIPPED_KEY]: skipped };
};

export const firstIncompletePhase1QuestionIndex = (questions, formData, getValue) => {
  const index = questions.findIndex((question) => {
    if (isPhase1QuestionSkipped(formData, question)) return false;
    const value = getValue(question, formData);
    return value === null || value === undefined || String(value).trim() === '';
  });
  return index < 0 ? questions.length : index;
};

export const withoutPhase1DraftMetadata = (formData) => {
  const payload = { ...formData };
  delete payload[PHASE1_SKIPPED_KEY];
  Object.keys(payload).forEach((key) => {
    if (key.startsWith('_dc_scratch_')) delete payload[key];
  });
  return payload;
};
